import { z } from 'zod';
export const TipTypeSchema = z.enum(['term', 'say', 'note', 'answer']);
/**
 * A tip as produced by the model. Kept deliberately flat so it maps cleanly to a
 * JSON schema for structured outputs: `term` is an empty string unless type is "term".
 */
export const ModelTipSchema = z.object({
    type: z.enum(['term', 'say', 'note']),
    term: z.string().max(80).default(''),
    text: z.string().min(1).max(400),
});
export const ModelTipsResponseSchema = z.object({
    tips: z.array(ModelTipSchema).max(6),
});
export const ModelAnswerSchema = z.object({
    answer: z.string().min(1).max(1200),
});
/** A tip as delivered to clients and stored as a MeetingTip. */
export const TipSchema = z.object({
    id: z.string(),
    type: TipTypeSchema,
    term: z.string().nullable(),
    text: z.string(),
    createdAt: z.string(),
    /** Milliseconds since the call started, for placing the tip on the transcript timeline. */
    callOffsetMs: z.number().int().nonnegative(),
    useful: z.boolean().nullable().optional(),
});
export const TriggerSchema = z.enum(['cadence', 'suggest_now', 'ask']);
/** JSON schema used for Claude structured outputs (mirrors ModelTipsResponseSchema). */
export const TIPS_JSON_SCHEMA = {
    type: 'object',
    additionalProperties: false,
    required: ['tips'],
    properties: {
        tips: {
            type: 'array',
            items: {
                type: 'object',
                additionalProperties: false,
                required: ['type', 'term', 'text'],
                properties: {
                    type: { type: 'string', enum: ['term', 'say', 'note'] },
                    term: { type: 'string' },
                    text: { type: 'string' },
                },
            },
        },
    },
};
export const ANSWER_JSON_SCHEMA = {
    type: 'object',
    additionalProperties: false,
    required: ['answer'],
    properties: { answer: { type: 'string' } },
};
//# sourceMappingURL=tips.js.map